import React from 'react'
import ReactDOM from 'react-dom'
import { NotificationPreviewButton } from './Button'

export default class NotificationPreviewContainer {
  constructor(element, isLoggedIn = false, pnsToken = ""){
    this.element = element
    this.isLoggedIn = isLoggedIn
    this.pnsToken = pnsToken
  }

  render(){
    ReactDOM.render(<NotificationPreviewButton isLoggedIn={this.isLoggedIn} token={this.pnsToken} />, this.element)
  }
}
